import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import apiService from './plugins/apiService'
import './plugins/element.js'
import 'nprogress/nprogress.css'

Vue.config.productionTip = false
// через this.$http в компонентах нужно обращаться к axios
Vue.prototype.$http = apiService
Vue.prototype.$mip = store.getters.isMethodInProgress
Vue.config.devtools = true
// создаем экземпляр Vue
new Vue({
  router,
  store,
  created() {
    // сохранение авторизации пользователя после перезагрузки страницы
    const userString = localStorage.getItem('user')
    if (userString) {
      const userData = JSON.parse(userString)
      this.$store.commit('SET_USER_DATA', userData)
    }
  },
  render: h => h(App)
}).$mount('#app')
